import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Row, Button } from 'react-bootstrap';

import { settingsActions } from 'pages/settings/containers/settingsContainer/actions';
import { getUserSettings } from 'selectors';
import { messageNotification } from 'helpers';

const PasswordResetForm = (props) => {
  const { inputs, password_reset, is_social_user } = props;
  const [laoding, setLoading] = useState(false);

  const handlePasswordReset = (event) => {
    if (inputs.email) {
      setLoading(true);
      props.dispatch(settingsActions.resetUserPassword(inputs, setLoading));
    } else {
      messageNotification('danger', 'Accounts Settings Update Failed', 'Email Address is required.');
    }
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label>Password</Form.Label>
      <Row className="d-flex align-items-center">
        {!is_social_user && (
          <Col sm="auto">
            <Button
              variant="primary"
              name="password-reset"
              value="Reset Your Password"
              onClick={handlePasswordReset}
              disabled={!password_reset}
            >
              {laoding && (
                <span
                  class="spinner-border spinner-border-sm pr-2"
                  style={{ marginRight: '8px' }}
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              Reset Your Password
            </Button>
          </Col>
        )}
        <Col sm="auto">
          <small>(Check your email account for instructions to reset your password)</small>
        </Col>
      </Row>
    </Form.Group>
  );
};

function mapStateToProps(state) {
  let { password_reset, is_social_user } = getUserSettings(state);

  return {
    password_reset,
    is_social_user
  };
}

export default connect(mapStateToProps)(PasswordResetForm);
